import(/* webpackMode: "eager", webpackExports: ["Breadcrumb","Skeleton","Empty"] */ "__barrel_optimize__?names=Breadcrumb,Empty,Skeleton!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["message","success","error"] */ "__barrel_optimize__?names=message!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Product/ContactBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Product/imageGallery.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Product/ImageGallerySwiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Product/Information.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Product/product-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Product/ProductDescription.tsx");
